module.exports = __webpack_public_path__ + "assets/faceSmile.a5078d1bca87cd77a7bb8cb9e6c55478.png";